import React, { Component } from 'react';
import { Modal, Header, Button, Tab } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { ReactHeight } from 'react-height';
import { createToast, toastType } from 'Common/ToastHelper';
import { setSelectedTab } from '../state/settings/actions';
import { FieldEnum } from 'Common/FieldEnum';
import EditForm from './EditForm';
import ChargeLimit from './ChargeLimit';
import ServingConfiguration from './ServingConfiguration';
import { LoadingModal } from '../../../components';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';
import StaplesForm from './StaplesForm';
import { OrderPreferenceEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import {
  getWareHouseAndKitchenDropDownDataSource,
  getOptionsData,
  containDuplicateWarehouseKitchenEntries,
  removeNullItemsFromObjectList,
} from './../helpers/SiteSetupHelpers';

class EditModalContainer extends Component {
  state = {
    isValid: true,
    height: 0,
  };
  componentDidUpdate(prevProps) {
    if (this.props.isEditValid !== prevProps.isEditValid) {
      this.setState({ isValid: this.props.isEditValid });
    }
    if (
      prevProps.fetching !== this.props.fetching &&
      this.props.fetching === false
    ) {
      this.props.resetDirty();
    }
  }

  componentWillUnmount() {
    this.setState({ height: 0 });
  }

  handleSiteSubmit = values => {
    return {
      Id: values[FieldEnum.Id],
      Description: values[FieldEnum.Description],
      SiteGroupId: values[FieldEnum.SiteGroupId],
      SiteMasterTypeId: values[FieldEnum.SiteType],
      Contact: values[FieldEnum.Contact],
      ShipAddress1: values[FieldEnum.ShipAddress1],
      ShipAddress2: values[FieldEnum.ShipAddress2],
      ShipCity: values[FieldEnum.ShipCity],
      ShipState: values[FieldEnum.ShipState],
      ShipZipCode:
        values[FieldEnum.ShipZipCode] &&
        values[FieldEnum.ShipZipCode].length > 0
          ? values[FieldEnum.ShipZipCode].replace(/[^a-z0-9]+/g, '')
          : '',
      ManagersEmailId: values[FieldEnum.ManagersEmailId],
      ShipAttention: values[FieldEnum.ShipAttention],
      AlternateProvisionTypeId: values[FieldEnum.AlternateProvisionId],
      IsActive: values[FieldEnum.IsActive],
      BillAttention: values[FieldEnum.BillAttention],
      BillAddress1: values[FieldEnum.BillAddress1],
      BillAddress2: values[FieldEnum.BillAddress2],
      BillCity: values[FieldEnum.BillCity],
      BillState: values[FieldEnum.BillState],
      BillZipCode:
        values[FieldEnum.BillZipCode] &&
        values[FieldEnum.BillZipCode].length > 0
          ? values[FieldEnum.BillZipCode].replace(/[^a-z0-9]+/g, '')
          : '',
      Phone: this.formatPhoneNumber(values[FieldEnum.Phone]),
      Route: values[FieldEnum.Route],
      OrderPreferenceId: values[FieldEnum.OrderPreferenceId],
      VendorId:
        values[FieldEnum.SiteType] !== 1 ? values[FieldEnum.VendorId] : null,
      IsBillAddSameAsShipAdd: values[FieldEnum.IsBillAddSameAsShipAdd],
    };
  };

  handleServerConfigSubmit = values => {
    return {
      PrimarySiteId: values[FieldEnum.ServingSite],
      AttendanceFactor: values[FieldEnum.AttendanceFactor],
      ChargeFlag: values[FieldEnum.ChargeFlag],
      SevereNeed: values[FieldEnum.SevereNeed] === true ? 'Y' : 'N',
      AreaEligible: values[FieldEnum.AreaEligible] === true ? 'Y' : 'N',
      ReimbursableBreakfastId: values[FieldEnum.BreakfastId],
      ReimbursableLunchId: values[FieldEnum.LunchId],
      ReimbursableSupperId: values[FieldEnum.SupperId],
      AdditionalCredit: values[FieldEnum.AdditionalCredit],
      MinPPToDiscount: values[FieldEnum.MinimumPayment],
      AlaCarteExpense: values[FieldEnum.AlaCarteExpense],
      AlaCarteExpAmount:
        values[FieldEnum.AlaCarteExpense] === 'Y'
          ? values[FieldEnum.AlaCarteAmount]
          : 0,
      AlaCarteExpFrequency:
        values[FieldEnum.AlaCarteExpense] === 'Y'
          ? values[FieldEnum.AlaCarteExpFrequency]
          : '',
    };
  };

  formatPhoneNumber = phoneNumber => {
    let number = '';
    let extension = '';

    if (phoneNumber && phoneNumber.length > 0) {
      number = phoneNumber.substr(0, 14);
      number = number.replace(/[^a-z0-9]+/g, '');

      if (phoneNumber.length > 14) {
        extension = phoneNumber.substr(14, phoneNumber.length - 1);
      }
    }

    return number + extension;
  };

  onSaveClick = () => {
    const { modalData } = this.props;
    const isNew = modalData
      ? modalData && modalData.Id === ''
        ? true
        : false
      : true;

    const isSchool = modalData.SiteMasterTypeId === SiteTypeEnum.School;
    if (this.SiteDetailsForm.invalid) {
      this.SiteDetailsForm.submit();
      this.props.setSelectedTab(0);
    } else if (
      !this.props.isNewSite &&
      this.ServingConfigurationForm &&
      this.ServingConfigurationForm.invalid
    ) {
      this.ServingConfigurationForm.submit();
      this.props.setSelectedTab(1);
    } else if (
      this.WarehousesKitchenConfigForm &&
      this.WarehousesKitchenConfigForm.invalid
    ) {
      this.WarehousesKitchenConfigForm.submit();
      this.scrollModalTo(0, 0);
      isNew || !isSchool
        ? this.props.setSelectedTab(1)
        : this.props.setSelectedTab(3);
    } else {
      const siteValues = this.SiteDetailsForm.submit();
      const wareHouseKitchenValue = this.WarehousesKitchenConfigForm.submit();
      const serverValues =
        this.ServingConfigurationForm &&
        this.props.modalData &&
        this.props.modalData.Id !== ''
          ? this.ServingConfigurationForm.submit()
          : {};
      if (
        siteValues.OrderPreferenceId &&
        siteValues.OrderPreferenceId !== OrderPreferenceEnum.vendorOnly &&
        wareHouseKitchenValue.WareHousesAndKitchens.length === 0
      ) {
        this.scrollModalTo(0, 0);
        isNew || !isSchool
          ? this.props.setSelectedTab(1)
          : this.props.setSelectedTab(3);
        createToast(
          toastType.error,
          'Error',
          'Please select order preference to Distributor Direct OR select a Warehouse/Kitchen to order from.',
          true
        );
      } else if (
        wareHouseKitchenValue.WareHousesAndKitchens &&
        containDuplicateWarehouseKitchenEntries(
          wareHouseKitchenValue.WareHousesAndKitchens
        )
      ) {
        this.scrollModalTo(0, 0);
        isNew || !isSchool
          ? this.props.setSelectedTab(1)
          : this.props.setSelectedTab(3);
        createToast(
          toastType.error,
          'Error',
          'Please clear duplicate warehouses or kitchens.',
          true
        );
      } else {
        this.props.handleEditSubmit({
          ...siteValues,
          ...wareHouseKitchenValue,
          ...serverValues,
        });
      }
    }
  };

  setContainerHeight = height => {
    if (this.state.height <= height) {
      this.setState({ height: height });
    }
  };

  handleWarehouseKitchenSubmit = values => {
    const WareHousesAndKitchens = removeNullItemsFromObjectList(
      values[FieldEnum.WareHousesAndKitchens]
    );
    return {
      StapleDayOfWeekId: values[FieldEnum.StapleDayOfWeekId],
      StapleStorageLocationId: values[FieldEnum.StapleStorageLocationId],
      StapleRoute: values[FieldEnum.StapleRoute],
      WareHousesAndKitchens: WareHousesAndKitchens,
    };
  };
  getSourceForWarehouseAndKitchen = () => {
    const { modalData, allSiteDetails } = this.props;
    return getWareHouseAndKitchenDropDownDataSource(
      1,
      modalData.Id,
      allSiteDetails
    );
  };
  getStorageLocation = () => {
    const { storageLocations } = this.props;
    return getOptionsData(storageLocations);
  };
  getHandlingFeeList = () => {
    const { handlingFee } = this.props;
    return getOptionsData(handlingFee);
  };
  scrollModalTo = (x = 0, y = 0) => {
    const mainSection = document.getElementsByClassName('site-setup-content');

    if (mainSection && mainSection.length !== 0) {
      mainSection[0].scrollTo(x, y);
    }
  };
  render() {
    const { modalData, enrollmentData, servedItems, siteSetup } = this.props;
    const { isSubmitting, isReadOnly, fetching } = this.props;
    const isNew = modalData
      ? modalData && modalData.Id === ''
        ? true
        : false
      : true;

    const isSchool = modalData.SiteMasterTypeId === SiteTypeEnum.School;
    const isHandlingFeeAvailable = isNew
      ? false
      : modalData.VendorId
      ? true
      : false;
    const billZipCode =
      modalData.BillZipCode &&
      (modalData.BillZipCode.length <= 5
        ? modalData.BillZipCode.substr(0, 5)
        : modalData.BillZipCode.substr(0, 5) +
          '-' +
          modalData.BillZipCode.substr(5));
    const shipZipCode =
      modalData.ShipZipCode &&
      (modalData.ShipZipCode.length <= 5
        ? modalData.ShipZipCode.substr(0, 5)
        : modalData.ShipZipCode.substr(0, 5) +
          '-' +
          modalData.ShipZipCode.substr(5));

    let panes = [
      {
        menuItem: 'Site Details',
        pane: (
          <Tab.Pane attached={false} key="siteDetials">
            <Modal.Content className="p-t-0" scrolling>
              {' '}
              {modalData && (
                <EditForm
                  ref={instance => {
                    this.SiteDetailsForm = instance;
                  }}
                  onSubmit={this.handleSiteSubmit}
                  initialValues={{
                    [FieldEnum.Id]: modalData.Id,
                    [FieldEnum.Description]: modalData.Description,
                    [FieldEnum.SiteGroupId]: modalData.SiteGroupId,
                    [FieldEnum.ManagersEmailId]: modalData.ManagersEmailId,
                    [FieldEnum.Contact]: modalData.Contact,
                    [FieldEnum.ShipAddress1]: modalData.ShipAddress1,
                    [FieldEnum.ShipAddress2]: modalData.ShipAddress2,
                    [FieldEnum.ShipAttention]: modalData.ShipAttention,
                    [FieldEnum.IsLicensed]: modalData.IsLicensed,
                    [FieldEnum.IsActive]: isNew ? true : modalData.IsActive,
                    [FieldEnum.SiteType]: isNew
                      ? 1
                      : modalData.SiteMasterTypeId,
                    [FieldEnum.ShipCity]: modalData.ShipCity,
                    [FieldEnum.ShipState]: modalData.ShipState,
                    [FieldEnum.ShipZipCode]: shipZipCode,
                    [FieldEnum.MBEDate]: modalData.MBEDate,
                    [FieldEnum.ManagersEmailId]: modalData.ManagersEmailId,
                    [FieldEnum.AlternateProvisionId]: isNew
                      ? 0
                      : modalData.AlternateProvisionTypeId,
                    [FieldEnum.Free]: isNew
                      ? null
                      : enrollmentData && enrollmentData.Free,
                    [FieldEnum.Reduced]: isNew
                      ? null
                      : enrollmentData && enrollmentData.Reduced,
                    [FieldEnum.Paid]: isNew
                      ? null
                      : enrollmentData && enrollmentData.Paid,
                    [FieldEnum.Membership]: isNew
                      ? null
                      : enrollmentData && enrollmentData.Membership,
                    [FieldEnum.BillAddress1]: modalData.BillAddress1,
                    [FieldEnum.BillAddress2]: modalData.BillAddress2,
                    [FieldEnum.BillCity]: modalData.BillCity,
                    [FieldEnum.BillState]: modalData.BillState,
                    [FieldEnum.BillZipCode]: billZipCode,
                    [FieldEnum.Phone]:
                      modalData.Phone &&
                      '(' +
                        modalData.Phone.substr(0, 3) +
                        ') ' +
                        modalData.Phone.substr(3, 3) +
                        '-' +
                        modalData.Phone.substr(6, 4) +
                        modalData.Phone.substr(10, modalData.Phone.length - 1),
                    [FieldEnum.Route]: modalData.Route,
                    [FieldEnum.OrderPreferenceId]: isNew
                      ? OrderPreferenceEnum.vendorOnly
                      : modalData.OrderPreferenceId,
                    [FieldEnum.VendorId]: modalData.VendorId,
                    [FieldEnum.ApplyHandlingFee]: isHandlingFeeAvailable,
                    [FieldEnum.BillAttention]: modalData.BillAttention,
                    [FieldEnum.IsBillAddSameAsShipAdd]:
                      modalData.IsBillAddSameAsShipAdd,
                  }}
                  setIsValid={isValid => {
                    this.setState({ isValid });
                  }}
                  siteGroups={this.props.siteGroups}
                  isNew={isNew}
                  isActiveDisabled={modalData.IsLicensed ? true : false}
                  siteSetup={this.props.siteSetup}
                  showDirtyLinkConfirm={this.props.showDirtyLinkConfirm}
                  getHandlingFeeList={this.getHandlingFeeList}
                />
              )}
            </Modal.Content>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Serving Configuration',
        pane: (
          <Tab.Pane attached={false} key="servingConfig">
            <Modal.Content className="p-t-0" scrolling>
              {modalData && (
                <ServingConfiguration
                  ref={instance => {
                    this.ServingConfigurationForm = instance;
                  }}
                  onSubmit={this.handleServerConfigSubmit}
                  initialValues={{
                    [FieldEnum.ServingSite]: modalData.PrimarySiteId,
                    [FieldEnum.AttendanceFactor]: modalData.AttendanceFactor
                      ? modalData.AttendanceFactor.toFixed(2)
                      : (0.0).toFixed(2),
                    [FieldEnum.ChargeFlag]: modalData.ChargeFlag,
                    [FieldEnum.SevereNeed]: modalData.SevereNeed === 'Y',
                    [FieldEnum.AreaEligible]: modalData.AreaEligible === 'Y',
                    [FieldEnum.AdditionalCredit]: modalData.AdditionalCredit
                      ? modalData.AdditionalCredit.toFixed(2)
                      : (0.0).toFixed(2),
                    [FieldEnum.MinimumPayment]: modalData.MinPPToDiscount
                      ? modalData.MinPPToDiscount.toFixed(2)
                      : (0.0).toFixed(2),
                    [FieldEnum.AlaCarteExpense]: modalData.AlaCarteExpense
                      ? modalData.AlaCarteExpense
                      : 'N',
                    [FieldEnum.AlaCarteAmount]: modalData.AlaCarteExpAmount
                      ? modalData.AlaCarteExpAmount.toFixed(2)
                      : (0.0).toFixed(2),
                    [FieldEnum.AlaCarteExpFrequency]:
                      modalData.AlaCarteExpense === 'N'
                        ? 'D'
                        : modalData.AlaCarteExpFrequency,
                    [FieldEnum.BreakfastId]: modalData.ReimbursableBreakfastId,
                    [FieldEnum.LunchId]: modalData.ReimbursableLunchId,
                    [FieldEnum.SupperId]: modalData.ReimbursableSupperId,
                  }}
                  servingSitesInfo={siteSetup}
                  modalData={modalData}
                  servedItems={servedItems}
                  alaCarteDisabled={
                    modalData && modalData.AlaCarteExpense === 'Y'
                  }
                  updateServingSiteDetails={updateObj =>
                    this.props.updateSiteDetails(updateObj)
                  }
                  ownSiteId={modalData.Id}
                />
              )}
            </Modal.Content>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Charge Limits by Status',
        pane: (
          <Tab.Pane attached={false} key="limits">
            <Modal.Content className="p-t-0" scrolling>
              <ChargeLimit isReadOnly={isReadOnly} />
            </Modal.Content>
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Warehouse(s)/Kitchen(s)',
        pane: (
          <Tab.Pane attached={false} key="warehousesKitchenConfig">
            <Modal.Content className="p-t-0">
              <StaplesForm
                ref={instance => {
                  this.WarehousesKitchenConfigForm = instance;
                }}
                onSubmit={this.handleWarehouseKitchenSubmit}
                initialValues={{
                  [FieldEnum.StapleDayOfWeekId]: modalData.StapleDayOfWeekId,
                  [FieldEnum.StapleStorageLocationId]:
                    modalData.StapleStorageLocationId,
                  [FieldEnum.StapleRoute]: modalData.StapleRoute,
                  [FieldEnum.WareHousesAndKitchens]:
                    modalData.WarehousesAndKitchens,
                }}
                setIsValid={isValid => {
                  this.setState({ isValid });
                }}
                primaryId={modalData.PrimarySiteId}
                getSourceForWarehouseAndKitchen={
                  this.getSourceForWarehouseAndKitchen
                }
                getStorageLocation={this.getStorageLocation}
                {...this.props}
              />
            </Modal.Content>
          </Tab.Pane>
        ),
      },
    ];

    panes = isNew || !isSchool ? [panes[0], panes[3]] : panes;

    return (
      <Modal
        open={this.props.showEditModal}
        onClose={this.props.onClose}
        closeIcon
        closeOnRootNodeClick={false}
      >
        {fetching && <LoadingModal />}
        <Header
          content={`${
            isNew
              ? 'Add New Site'
              : 'Edit Site ' + modalData
              ? modalData && modalData.Description
              : ''
          }`}
          icon={isNew ? 'plus' : 'signup'}
        />
        <ReactHeight
          onHeightReady={height => this.setContainerHeight(height)}
          style={{
            height: this.state.height !== 0 ? this.state.height + 'px' : '',
          }}
        >
          <Tab
            panes={panes}
            menu={{ secondary: true }}
            renderActiveOnly={false}
            activeIndex={this.props.selectedTab}
            onTabChange={(e, { activeIndex }) => {
              this.props.setSelectedTab(activeIndex);
              this.scrollModalTo(0, 0);
            }}
          />
        </ReactHeight>
        <Modal.Actions>
          <Button
            loading={isSubmitting}
            positive={!isSubmitting}
            disabled={isReadOnly || isSubmitting}
            inverted
            color="orange"
            size="big"
            content="Save"
            onClick={this.onSaveClick.bind(this)}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = ({
  SiteSetupState: { page, settings, siteDetails },
}) => {
  return {
    isSubmitting: page.result.isSubmitting,
    errors: page.result.errors,
    selectedTab: settings.selectedTab,
    allSiteDetails: page.siteSetup.Data,
    storageLocations: siteDetails.storageLocations,
    handlingFee: siteDetails.handlingFee,
    fetching: siteDetails.fetching,
  };
};

export const EditModal = connect(mapStateToProps, { setSelectedTab })(
  EditModalContainer
);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/EditModal.js